module.exports = __webpack_public_path__ + "static/img/item6.b9ced3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/item6.png
// module id = K0vl
// module chunks = 63